"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.titleType = void 0;
const types_1 = require("../../types");
exports.titleType = [
    {
        name: "Clear",
        value: types_1.Vehicle.TitleTypeEnum.Clear,
        description: "Vehicle is clear of any state-issued title brands, past or present."
    },
    {
        name: "Salvage",
        value: types_1.Vehicle.TitleTypeEnum.Salvage,
        description: "Vehicle has been damaged and the cost to repair is/was significant (usually over a certain percentage of fair market value), or was declared a total loss by the insurer"
    },
    {
        name: "Rebuilt & Reconstructed",
        value: types_1.Vehicle.TitleTypeEnum.Rebuilt,
        description: "Salvage vehicle that has been repaired and restored to operation using new/used parts."
    },
    {
        name: 'Lemon & Manufacture Buyback',
        value: types_1.Vehicle.TitleTypeEnum.Lemon,
        description: "Vehicle that has been repurchased or had its price adjusted by the manufacturer due to major problems or failure to conform to factory warranties."
    },
    {
        name: 'Flood & Water Damage',
        value: types_1.Vehicle.TitleTypeEnum.Flood,
        description: "Vehicle has been in a flood or has sustained extensive water damage."
    }
];
